import { createRouter, createWebHistory } from 'vue-router'

import HomeView from './pages/home';
import ProtocolView from './pages/protocol';
import PlantemplateView from './pages/plantemplate';
import ProjectDetailView from './pages/projectdetail';
import PostDetailView from './pages/postdetail';
import ProfileDetailView from './pages/profiledetail';

const routes = [
  { path: '/', redirect: 'home' },
  { path: '/home', name: 'home', component: HomeView },
  { path: '/protocol/:target', name: 'protocol', component: ProtocolView },
  { path: '/plan/template/detail', name: 'plantemplate', component: PlantemplateView },
  { path: '/project/detail', name: 'projectdetail', component: ProjectDetailView },
  { path: '/post/detail', name: 'postdetail', component: PostDetailView },
  { path: '/profile/detail', name: 'profiledetail', component: ProfileDetailView },
]

export default createRouter({
  history: createWebHistory(),
  routes,
})
